<template>
  <div>
    <carbonfootprint-wapper title="供应商基本信息">
      <div class="supplier-info">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="supplier-info-item">
              <div class="supplier-info-item-label">供应商编码：</div>
              <div class="supplier-info-item-value">
                {{ userInfo.companyId }}
              </div>
              <!-- 和产品确认公司id 当编码用 -->
            </div>
          </el-col>
          <el-col :span="12">
            <div class="supplier-info-item">
              <div class="supplier-info-item-label">供应商名称：</div>
              <div class="supplier-info-item-value">
                {{ userInfo.companyName }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-form
        ref="contactForm"
        :model="contactForm"
        label-width="110px"
        label-suffix=":"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item class="cursor-form-item" label="填报信息联系人">
              <el-input
                v-model="contactForm.contactName"
                placeholder="请输入填报信息联系人"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="填报信息联系电话" class="cursor-form-item">
              <el-input
                v-model="contactForm.contactPhone"
                placeholder="请输入填报信息联系电话"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </carbonfootprint-wapper>
    <carbonfootprint-wapper title="上传类型">
      <template #title>
        <div><span class="required">*</span>上传类型</div>
      </template>
      <div class="flex gap-5">
        <!-- <div class="flex items-center gap-1"><el-checkbox v-model="certificate" @change="handleChange('carbonCertList')"></el-checkbox>碳足迹证书</div>
              <div class="flex items-center gap-1"><el-checkbox v-model="report" @change="handleChange('carbonReportList')"></el-checkbox>碳足迹报告</div> -->
        <div class="flex items-center gap-1">
          <el-checkbox-group
            v-model="checkList"
            @change="handleChangeCheckList"
          >
            <el-checkbox
              v-for="item in options"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </carbonfootprint-wapper>
    <div v-if="checkListItemList.length > 0" class="tabs-container">
      <el-tabs v-model="activeIndex" type="card" @tab-click="handleTab">
        <el-tab-pane
          v-for="item in checkListItemList"
          :key="item.id"
          :label="item.label"
          :name="item.id"
        >
          <!-- {{ item }} -->
          <div
            v-if="item.id === 'certificate'"
            class="tabs-wapper"
            title="碳足迹证书"
            collapsible
          >
            <carbonfootprint-certificate
              ref="carbonfootprintCertificate"
              :certificate="carbonCertList"
            ></carbonfootprint-certificate>
          </div>
          <div
            v-if="item.id === 'report'"
            class="tabs-wapper"
            title="碳足迹报告"
            collapsible
          >
            <carbonfootprint-report
              ref="carbonfootprintReport"
              :report="carbonReportList"
            ></carbonfootprint-report>
          </div>
          <div
            v-if="item.id === 'factory'"
            class="tabs-wapper"
            title="绿色工厂评价"
            collapsible
          >
            <greeFactoryEvalution
              ref="greeFactoryEvalution"
              :factory="factory"
            ></greeFactoryEvalution>
          </div>
          <div
            v-if="item.id === 'supplyChain'"
            class="tabs-wapper"
            title="绿色供应链评价"
            collapsible
          >
            <supplyChainListCom
              ref="supplyChain"
              :supply-chain="supplyChain"
            ></supplyChainListCom>
          </div>
          <div
            v-if="item.id === 'productList'"
            class="tabs-wapper"
            title="中国绿色产品认证"
            collapsible
          >
            <greenProductList
              ref="productList"
              :product-list="productList"
            ></greenProductList>
          </div>
          <div
            v-if="item.id === 'other'"
            class="tabs-wapper"
            title="其他"
            collapsible
          >
            <otherListCom ref="other" :other="other"></otherListCom>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="footer-btn">
      <eui-btn
        type="secondary"
        width="120"
        size="44"
        font-size="14px"
        @click="handleClose"
        >关闭并返回首页</eui-btn
      >
      <eui-btn
        v-if="$route.query.type !== 'detail'"
        type="weak"
        width="120"
        size="44"
        font-size="14px"
        @click="handleSave"
        >保存</eui-btn
      >
      <eui-btn
        v-if="$route.query.type !== 'detail'"
        width="120"
        size="44"
        font-size="14px"
        @click="handleSubmit"
        >提交</eui-btn
      >
    </div>
    <div class="contactUs">
      <div class="left"></div>
      <div class="center">
        <div class="item">
          <span class="name"
            ><eui-icon
              icon="eicon-r-yonghu"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon
            >高经理</span
          >
          <span class="phone"
            ><eui-icon
              icon="eicon-r-dianhua"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon
            >010-62329096</span
          >
          <!-- <span class="email"><eui-icon icon="eicon-l-youjian" fontSize="16px" color="#0064C8" class="itemIcon"></eui-icon>gaorw@ztzh.com.cn</span> -->
        </div>
        <div class="item">
          <span class="name"
            ><eui-icon
              icon="eicon-r-yonghu"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon
            >张经理</span
          >
          <span class="phone"
            ><eui-icon
              icon="eicon-r-dianhua"
              font-size="16px"
              color="#0064C8"
              class="itemIcon"
            ></eui-icon
            >010-62329097</span
          >
          <!-- <span class="email"><eui-icon icon="eicon-l-youjian" fontSize="16px" color="#0064C8" class="itemIcon"></eui-icon>wzjinht@sinopec.com</span> -->
        </div>
      </div>

      <div class="right"></div>
    </div>
    <EDialog
      :center-dialog-visible="submitVisible"
      dialog-type="other"
      :dialog-title="'提交报告'"
      @resetPopupData="resetPopupData"
      @submitPopupData="handleSubmitData"
    >
      <div>确认您填报的内容数据真实和有效！</div>
      <div class="opera">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="0"
          class="demo-ruleForm"
        >
          <el-form-item prop="isAgree">
            <!-- {{ ruleForm.isAgree }} -->
            <el-checkbox
              v-model="ruleForm.isAgree"
              :true-label="'1'"
              :false-label="''"
            ></el-checkbox
            ><span class="agreeTxt"
              >我已阅读并同意<eui-btn type="text" @click="toAgreement"
                >《绿色低碳信息提供告知同意书》</eui-btn
              ></span
            >
          </el-form-item>
        </el-form>
      </div>
    </EDialog>
    <CarbonFootprintAgreeDialog
      :agree-visible="agreeVisible"
      @change="agreeVisible = false"
    ></CarbonFootprintAgreeDialog>
  </div>
</template>

<script>
import api from '@/modules/projectA/api/carbonfoot';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import CarbonfootprintWapper from './components/carbonfootprintWapper';
import CarbonfootprintCertificate from './components/carbonfootprintCertificate';
import CarbonfootprintReport from './components/carbonfootprintReport';
import greeFactoryEvalution from './components/greeFactoryEvalution';
import supplyChainListCom from './components/supplyChain';
import greenProductList from './components/greenProductList';
import otherListCom from './components/otherList';
import CarbonFootprintAgreeDialog from './components/CarbonFootprintAgreeDialog.vue';

const decodeMask = (S) => {
  const values = [2, 4, 8, 16, 32, 64];
  return values.filter((v) => (S & v) !== 0);
};
export default {
  components: {
    CarbonfootprintWapper,
    CarbonfootprintCertificate,
    CarbonfootprintReport,
    greeFactoryEvalution,
    supplyChainListCom,
    greenProductList,
    otherListCom,
    EDialog,
    CarbonFootprintAgreeDialog,
  },
  data() {
    return {
      submitVisible: false,
      ruleForm: {
        isAgree: false,
      },
      rules: {
        isAgree: [
          {
            validator: (rule, value, callback) => {
              if (value === '' || !value) {
                callback(
                  new Error('请阅读并同意《绿色低碳信息提供告知同意书》')
                );
              } else {
                callback();
              }
            },
            require: true,
            message: '请阅读并同意《绿色低碳信息提供告知同意书》',
            trigger: 'change',
          },
        ],
      },
      agreeVisible: false,
      carbonCertList: [],
      carbonReportList: [],
      factory: [],
      supplyChain: [],
      productList: [],
      other: [],
      carbonFootprintId: '',
      options: [
        {
          id: 'certificate',
          label: '碳足迹证书',
          value: 2,
          key: 'carbonCertList',
          ref: 'carbonfootprintCertificate',
        },
        {
          id: 'report',
          label: '碳足迹报告',
          value: 4,
          key: 'carbonReportList',
          ref: 'carbonfootprintReport',
        },
        {
          id: 'factory',
          label: '绿色工厂评价',
          value: 8,
          key: 'factoryList',
          ref: 'greeFactoryEvalution',
        },
        {
          id: 'supplyChain',
          label: '绿色供应链评价',
          value: 16,
          key: 'supplyChainList',
          ref: 'supplyChain',
        },
        {
          id: 'productList',
          label: '中国绿色产品认证',
          value: 32,
          key: 'productList',
          ref: 'productList',
        },
        {
          id: 'other',
          label: '其他',
          value: 64,
          key: 'otherList',
          ref: 'other',
        },
      ],
      checkList: [],
      checkListItemList: [],
      activeIndex: '',
      contactForm: {
        contactName: '',
        // 填报信息联系电话
        contactPhone: '',
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  mounted() {
    this.getInitData();
  },
  methods: {
    handleChangeCheckList(value) {
      console.log(value);
      if (value.length === 0) {
        this.checkListItemList = [];
        this.activeIndex = '';
        return;
      }
      this.checkListItemList = this.options.filter((item) =>
        value.includes(item.value)
      );
      if (this.checkListItemList.length === 1) {
        this.activeIndex = this.checkListItemList[0].id;
        return false;
      }
      if (
        !this.checkListItemList.find((item) => item.id === this.activeIndex)
      ) {
        this.activeIndex = this.checkListItemList[0].id;
      }
    },
    handleTab(row) {
      // console.log(row);
      // this.activeIndex = row.index;
    },
    // handleChange(list) {
    //   this[list] = [];
    // },
    async getInitData() {
      // if (this.$route.query.id) {
      const { code, data } = await api.getDraft();
      if (code === '200' && data) {
        this.carbonCertList = data.carbonCertList || [];
        this.carbonReportList = data.carbonReportList || [];

        this.factory = data.factoryList || [];
        this.supplyChain = data.supplyChainList || [];
        this.productList = data.productList || [];
        this.other = data.otherList || [];
        this.checkList = decodeMask(data.dataType);
        console.log(this.checkList, 123123);

        this.contactForm = {
          contactName: data.contactName || '',
          contactPhone: data.contactPhone || '',
        };
        this.checkListItemList = this.options.filter((item) =>
          this.checkList.includes(item.value)
        );
        this.activeIndex = this.checkListItemList[0].id;
      }
      // }
    },
    handleClose() {
      this.$router.push('/CarbonfootprintManage/Carbonfootprint');
    },
    async getData() {
      const tasks = [];

      const that = this;
      this.checkListItemList.forEach((item) => {
        tasks.push(
          that.$refs[item.ref][0]
            .submit()
            .then((res) => ({
              id: item.id,
              key: item.key,
              ...res,
            }))
            .catch((err) => ({
              id: item.id,
              key: item.key,
              success: false,
            }))
        );
      });

      const results = await Promise.all(tasks);
      const submitData = {};

      const tabsSubmit = [];

      results.forEach(({ id, key, success, data }) => {
        if (success) {
          submitData[key] = data;
        } else {
          // this.$message.error(`${key}校验不通过`);
          tabsSubmit.push(id);
        }
      });
      if (
        tabsSubmit.length > 0 &&
        tabsSubmit.indexOf(this.activeIndex) === -1
      ) {
        const [firstTab] = tabsSubmit;
        this.activeIndex = firstTab;
      }

      return tabsSubmit.length === 0 ? submitData : null;
    },
    async getSaveData() {
      const submitData = {};

      const that = this;
      this.checkListItemList.forEach((item) => {
        submitData[item.key] = that.$refs[item.ref][0].save();
      });

      // const results = await Promise.all(tasks);

      // results.forEach(({ key, success, data }) => {
      //   if (success) {
      //     submitData[key] = data;
      //   }
      // });

      return submitData;
    },
    async handleSave() {
      if (this.checkList.length === 0) {
        this.$message.error('请选择上传类型');
        return;
      }
      // const carbonCertList =
      //   (this.$refs.carbonfootprintCertificate &&
      //     this.$refs.carbonfootprintCertificate[0].save()) ||
      //   [];
      // const carbonReportList =
      //   (this.$refs.carbonfootprintReport &&
      //     this.$refs.carbonfootprintReport[0].save()) ||
      //   [];

      // const factoryList =
      //   (this.$refs.greeFactoryEvalution &&
      //     this.$refs.greeFactoryEvalution[0].save()) ||
      //   [];
      // const supplyChainList =
      //   (this.$refs.supplyChain && this.$refs.supplyChain[0].save()) || [];
      // const productList =
      //   (this.$refs.productList && this.$refs.productList[0].save()) || [];
      // const otherList = (this.$refs.other && this.$refs.other[0].save()) || [];
      const submitData = await this.getSaveData();
      this.submitDataFn(
        {
          ...submitData,
        },
        0,
        '/CarbonfootprintManage/Carbonfootprint'
      );
      // const submitData = await this.getData();
      // this.submitDataFn(
      //   submitData,
      //   0,
      //   '/CarbonfootprintManage/Carbonfootprint'
      // );
      // console.log(submitData);
    },
    submitDataFn(submitData, staus, callbackUrl) {
      const submitType = {
        0: 'draft',
        1: 'submit',
      };
      api[submitType[staus]]({
        // carbonFootprintId: this.$route.query.id || '',
        supplierCode: this.userInfo.companyId,
        dataType: this.checkList.reduce((acc, item) => acc + item, 0),

        ...submitData,
        ...this.contactForm,
      }).then((res) => {
        const { code } = res;
        if (code === '200') {
          this.$message.success('操作成功！');
          if (callbackUrl) {
            this.$router.push(callbackUrl);
          }
        }
      });
      console.log(submitData);
    },
    async handleSubmit() {
      if (this.checkList.length === 0) {
        this.$message.error('请选择上传类型');
        return;
      }
      const submitData = await this.getData();
      if (submitData) {
        this.submitVisible = true;
      }
    },
    async handleSubmitData() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const submitData = await this.getData();
          this.submitDataFn(
            submitData,
            1,
            '/CarbonfootprintManage/Carbonfootprint'
          );
          console.log(submitData);
        }
      });
    },
    resetPopupData() {
      this.submitVisible = false;
    },

    toAgreement() {
      this.agreeVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.supplier-info {
  width: 100%;

  .supplier-info-item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    .supplier-info-item-label {
      width: 110px;
      text-align: right;
      color: #666;
    }
    .supplier-info-item-value {
      // width: 450px;
      color: #333;
    }
  }
}
.required {
  color: #f0250f;
}
.footer-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 20px 80px;
  ::v-deep button {
    white-space: nowrap;
  }
}
.agreeTxt {
  margin-left: 10px;
}

.contactUs {
  width: 100%;
  height: 100px;
  margin: 0 auto;

  background-size: 1200px 100px;
  margin-bottom: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333;
  .left {
    width: 330px;
    height: 100px;
    background: url('../../../../assets/img/carbonfootprint/contactUsLeft.png')
      no-repeat center center;
    background-size: 100% 100%;
  }
  .right {
    width: 220px;
    height: 100px;
    background: url('../../../../assets/img/carbonfootprint/contactUsRight.png')
      no-repeat center center;
    background-size: 100% 100%;
  }
  .center {
    background: rgba(37, 135, 255, 0.1);
    display: flex;
    flex: 1;
    justify-content: flex-start;
    padding-left: 154px;
    align-items: center;
    height: 100px;
    gap: 100px;
  }
  // gap: 100px;
  // padding-left: 464px;
  .item {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .name {
    font-size: 18px;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    // margin-right: 10px;
    line-height: 1;
  }
  .phone {
    font-size: 16px;
    // font-family: PingFangSC-Medium;
    // font-weight: 500;
    // margin-right: 30px;
    line-height: 1;
  }
  .email {
    font-size: 16px;
    // font-family: PingFangSC-Medium;
    // font-weight: 500;
  }
  .itemIcon {
    margin-right: 5px;
  }
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, 1) !important;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-top: 2px #2587ff solid !important;
  background: #f4f7ff !important;
  line-height: 48px;
  color: #2587ff !important;
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__nav-wrap.is-scrollable {
  padding: 0;
}

::v-deep .el-tabs__item {
  border-top: 2px #fff solid;
  line-height: 48px;
  height: 48px;
  color: #333333 !important;
}
.tabs-container {
  margin-top: 20px;
}
.tabs-wapper {
  background: #fff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-top: none;
  padding: 20px;
}

::v-deep.el-form-item {
  .el-form-item__label {
    padding: 0px;
    padding-right: 10px;
    color: #666;
  }
  .el-form-item__label:after {
    content: '';
    display: none;
  }
}

::v-deep.el-form-item.cursor-form-item {
  .el-form-item__label {
    line-height: 1;
  }
}

::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '*';
  color: rgba(240, 37, 15, 1);
  margin-right: 0px !important;
  /* margin-right: 4px; */
}
::v-deep.el-form .el-input__inner,
::v-deep.el-form .el-input,
::v-deep.el-form .el-date-editor,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-form .el-select .el-input__inner,
::v-deep.el-input--small .el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
::v-deep.el-radio {
  margin-right: 0px;
}
::v-deep.remark {
  padding-left: 0px !important;
}
::v-deep.el-radio__label {
  color: #333;
}
::v-deep.el-radio__input.is-checked + .el-radio__label {
  color: #333;
}
</style>
